<template src="./LoginComponent.html"></template>
<script>
import InputTextNormal from '@/components/inputs/input-text/normal/InputTextNormal.vue'
import InputPasswordNormal from '@/components/inputs/input-password/normal/InputPasswordNormal.vue'
import InputCheckboxOne from '@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue'
import ButtonLoginComponent from '@/components/buttons/button-login/ButtonLoginConponent.vue'
import { useAccountStore } from '@/stores/account.js'
import {AppConstant} from "@/supports/app.constant.ts";
import ErrorMessageService from "@/services/error-message.service.ts";
import {ref, computed} from "vue";
import {useRouter} from "vue-router";
import CommonService from "@/services/common.service.ts";
import {ConfirmText, ErrorText, ErrorMessageConstant} from "@/supports/error-message.constant";


export default {
  name: 'LoginComponent',
  components: { ButtonLoginComponent, InputCheckboxOne, InputTextNormal, InputPasswordNormal },
  setup() {
    const accountStore = useAccountStore()
    const errors = ref(true)
    const dataLogin = ref({
      user_email: {
        id: 'user_email',
        label: 'Email',
        placeholder: 'Email',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      user_password: {
        id: 'user_password',
        label: 'Mật khẩu',
        placeholder: 'Mật khẩu',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      keepPassword: {
        id: 'keep_password',
        label: 'Ghi nhớ đăng nhập',
        placeholder: '',
        value: '',
        error: '',
        isError: false,
        required: false
      }
    });
    const errorMessage = ref([])
    const router = useRouter()

    function onChange(value, name) {
      dataLogin.value[name].value = value
    }

    async function submitLogin() {
      for (const item in dataLogin.value) {
        validateLogin(dataLogin.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        const params = {
          mail_address: dataLogin.value.user_email.value,
          password: dataLogin.value.user_password.value,
          keep: dataLogin.value.keepPassword.value
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/auth/login';
        const loginRes = await accountStore.login(url, params);
        const errorMessageRes = await ErrorMessageService.getErrorMessage(loginRes)

        if(errorMessageRes !== undefined) {
          errorMessage.value = errorMessageRes
          if(typeof errorMessageRes === 'string') {
            errorMessage.value = [errorMessageRes]
          }
        }
        if(accountStore.isLogin) {
          router.push('/dashboard')
        }
      }

    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    function validateLogin(value, name) {
      if(name === 'user_email') {
        dataLogin.value.user_email.isError = false;
        dataLogin.value.user_email.error = ''
        errors.value = false
        if(!value) {
          dataLogin.value.user_email.isError = true;
          dataLogin.value.user_email.error = ErrorText.REQUIRED(dataLogin.value.user_email.label);
          errors.value = true
        }
        if(!errors.value && !CommonService.validateEmail(value)) {
          dataLogin.value.user_email.isError = true;
          dataLogin.value.user_email.error = ErrorMessageConstant.ERROR_MAIL_INVALID;
          errors.value = true
        }
      }
      if(name === 'user_password') {
        dataLogin.value.user_password.isError = false;
        dataLogin.value.user_password.error = ''
        errors.value = false
        if(!value) {
          dataLogin.value.user_password.isError = true;
          dataLogin.value.user_password.error = ErrorText.REQUIRED(dataLogin.value.user_password.label);
          errors.value = true
        }
      }
    }

    return {
      dataLogin,
      errorMessage,
      onChange,
      validateLogin,
      submitLogin
    }
  },
}
</script>
<style scoped lang="scss">
.login-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f5f7 url('@/assets/images/background-login.jpg') center center / cover no-repeat;
  .login-wrapper {
    display: flex;
    width: 100%;
    max-width: 1100px;
    height: 70vh;
    border-radius: 18px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(3px);
    .login-left {
      flex: 0.5;
      background: url('@/assets/images/login-form.jpg') center center / cover no-repeat;
      color: #fff;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 60px;
      &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.25);
      }
      h1, p {
        position: relative;
        z-index: 1;
      }
      h1 {
        font-size: 34px;
        font-weight: 700;
        line-height: 1.3;
        margin-bottom: 18px;
      }
      p {
        font-size: 15px;
        opacity: 0.9;
        line-height: 1.6;
      }
    }
    .login-right {
      flex: 0.9;
      background: rgba(255, 255, 255, 0.95);
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 60px;
      backdrop-filter: blur(4px);
      .logo {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 35px;
        .logo-text {
          font-size: 24px;
          font-weight: 800;
          color: #1b2e4b;
        }
      }
      .forgot-password {
        color: #696cff !important;
      }
    }
  }
}

@media (max-width: 900px) {
  .login-wrapper {
    flex-direction: column;
    height: auto;
  }
  .login-left, .login-right {
    width: 100%;
    padding: 40px 30px;
  }
  .login-left {
    height: 250px;
    text-align: center;
  }
}
</style>
